/* Mirror the native form so variant, stock and quantity validation stay in Dawn. */
if (!customElements.get('poa-mobile-purchase')) {
  customElements.define('poa-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.source = document.getElementById(this.dataset.source);
      this.action = this.querySelector('[data-purchase-action]');
      this.price = this.querySelector('[data-purchase-price]');
      this.selectionLabel = this.querySelector('[data-purchase-selection]');
      this.quantityLabel = this.querySelector('[data-purchase-quantity]');
      if (!this.source || !this.action || !this.price) return;
      this.onClick = () => {
        const submit = this.getSubmit();
        if (!submit || submit.disabled || submit.classList.contains('loading')) return;
        submit.click();
      };
      this.action.addEventListener('click', this.onClick);
      this.onSourceChange = () => this.sync();
      this.source.addEventListener('input', this.onSourceChange);
      this.source.addEventListener('change', this.onSourceChange);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.source, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class', 'value'] });
      this.sync();
    }
    getSubmit() {
      return this.source?.querySelector('product-form button[type="submit"]');
    }
    sync() {
      const submit = this.getSubmit();
      const variantInput = this.source.querySelector('product-form input[name="id"]');
      if (!submit || !variantInput) { this.hidden = true; return; }
      this.hidden = false;
      const busy = submit.classList.contains('loading');
      this.action.disabled = submit.disabled || variantInput.disabled || busy;
      const label = submit.querySelector('span:not(.loading__spinner)')?.textContent.trim() || this.dataset.unavailable;
      if (this.action.textContent !== label) this.action.textContent = label;
      this.action.setAttribute('aria-busy', String(busy));
      const variantNode = this.source.querySelector('variant-selects [data-selected-variant]');
      let variant;
      try { variant = variantNode ? JSON.parse(variantNode.textContent) : null; } catch { variant = null; }
      const selectedOptions = Array.from(this.source.querySelectorAll('variant-selects input:checked, variant-selects select'), input => input.value).filter(value => value !== 'Default Title');
      const selectedTitle = (selectedOptions.join(' / ') || (variant?.title !== 'Default Title' && variant?.title) || this.dataset.productTitle).replace(/\bPruple\b/g, 'Purple');
      if (this.selectionLabel && this.selectionLabel.textContent !== selectedTitle) this.selectionLabel.textContent = selectedTitle;
      const quantity = this.source.querySelector('quantity-input input[name="quantity"]')?.value || '1';
      const quantityText = `${this.dataset.quantityLabel}: ${quantity}`;
      if (this.quantityLabel && this.quantityLabel.textContent !== quantityText) this.quantityLabel.textContent = quantityText;
      if (!variantNode || (variant && String(variant.id) === variantInput.value)) {
        const nativePriceRoot = this.source.querySelector('[id^="price-"] .price');
        const nativePrice = nativePriceRoot?.querySelector(nativePriceRoot.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular:not(.variant-item__old-price)');
        if (nativePrice) {
          const priceText = `${nativePrice.textContent.trim()} ${this.dataset.each}`;
          if (this.price.textContent !== priceText) this.price.textContent = priceText;
        }
      } else if (variantNode && !variant) {
        this.price.textContent = this.dataset.unavailable;
        this.action.disabled = true;
      }
      this.dataset.variantId = variantInput.value;
      if (this.watchedSubmit !== submit) {
        this.intersection?.disconnect();
        this.watchedSubmit = submit;
        this.intersection = new IntersectionObserver(entries => {
          this.toggleAttribute('data-native-visible', entries.some(entry => entry.isIntersecting));
        });
        this.intersection.observe(submit);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.action?.removeEventListener('click', this.onClick);
      this.source?.removeEventListener('input', this.onSourceChange);
      this.source?.removeEventListener('change', this.onSourceChange);
    }
  });
}
